const pt = {
  onboarding: {
    countryQuestion: "Entendi! 🌍\n\nEm que país você está?",
    countryPlaceholder: "Em que país você está?",
    letsGo: "Vamos lá!",
    summaryIntro: "🎉 Ótimo, {name}! Está tudo pronto!",
    yourNameLabel: "seu nome",
    baseLanguageLabel: "idioma base",
    goalsHint: "Você pode ajustar sua meta de vocabulário e a duração do curso a qualquer momento na página Metas.",
    startLearning: "Comece a aprender {destLang}!",
  },
  header: {
    learner: "Aluno",
    home: "🏠 Início",
    allLessons: "📚 Todas as lições",
    currentLesson: "📖 Lição atual",
    flashcards: "🃏 Flashcards",
    progress: "📈 Progresso",
    goals: "🎯 Metas",
    grammarLab: "📘 Gramática",
    more: "⋯ Mais",
    myVocabulary: "📝 Meu Vocabulário",
    listenSpeak: "🎧 Ouvir e Falar",
    signOut: "↩ Sair",
  },
  lab: {
    title: "Laboratório de Ouvir e Falar",
    back: "Voltar",
    intro: "Tenha uma breve conversa falada com o Babi sobre um tópico que você já estudou.",
    pickTopic: "Escolha um tópico que você concluiu",
    noTopics: "Conclua uma lição primeiro e depois volte aqui para praticar a fala.",
    level: "Nível {level}",
    talkAbout: "Fale com o Babi sobre “{topic}”",
    speedLabel: "Velocidade da Babi",
    speedNormal: "Normal",
    speedSlow: "Lenta",
    speedNote: "A velocidade lenta usa mais dos seus minutos de voz para a mesma resposta.",
    startConversation: "Iniciar conversa",
    tapToStart: "Toque no microfone e responda ao Babi em turco.",
    continueConversation: "Responda à pergunta",
    finishSession: "Encerrar",
    voiceReviewHint: "Confira o que você disse e confirme — ou refaça.",
    voiceConfirm: "Confirmar",
    voiceRedo: "Refazer",
    voiceDenied: "A voz não está disponível sem acesso ao microfone. Toque no ícone do microfone a qualquer momento para tentar novamente.",
    lowBalanceWarning: "Seus minutos de voz para este ciclo mensal estão quase acabando.",
    thinking: "O Babi está pensando…",
    complete: "Sessão concluída",
    completeSub: "Bom treino. Volte quando quiser para conversar sobre outro tópico.",
    another: "Praticar outro tópico",
    done: "Concluído",
    replyError: "O Babi não conseguiu responder agora. Tente novamente em um instante.",
    tryAgain: "Tentar novamente",
    eliteUpsellTitle: "Ouvir e Falar é um recurso Elite",
    eliteUpsellBody: "Você está no plano Pro. Faça upgrade para Elite nas Configurações para praticar a fala com o Babi.",
    listenAgainButton: "Ouvir novamente",
    listenAgainPlaying: "Parar",
    translateButton: "Traduzir",
    translating: "Traduzindo…",
    translateFailed: "Não foi possível traduzir — tente novamente.",
    starsAriaLabel: "{stars} de 3",
    explainButton: "Explicar mais",
    explaining: "Explicando…",
    explainFailed: "Não foi possível obter uma explicação — tente novamente.",
    recapHeading: "Relatório da conversa",
    recapTitle: "Seu resumo",
    recapAvgStars: "Média desta sessão",
    recapTurnsCompleted: "{completed} de {total} turnos concluídos",
    recapErrorFree: "{n} turnos sem erros",
    recapMistakesByType: "Erros por tipo",
    recapCorrections: "O que foi corrigido",
    voiceMinutesTitle: "Minutos de voz",
    voiceMinutesLeft: "{amount} de {total} restantes neste ciclo",
    voiceMinutesNone: "Sem minutos mensais restantes neste ciclo",
  },
  dashboard: {
    greeting: "Olá, {name}! 👋",
    streakMsg: "Sequência de {streak} dias 🔥 — continue assim!",
    noStreak: "Comece sua primeira lição hoje!",
    streakProtectionDays: "{n} Dias de Proteção de Sequência conquistados 🛡️",
    dayInfo: "Idioma base: {lang} · Dia {day} de {total}",
    dayStreak: "dias seguidos",
    share: "Compartilhar",
    wordsLearned: "Palavras aprendidas",
    lessonsDone: "Lições concluídas",
    goalComplete: "Meta concluída",
    timeStudied: "Tempo estudado",
    hoursUnit: "Horas",
    paceTitle: "📊 Rastreador de ritmo diário",
    statusAhead: "🚀 {delta} palavras à frente!",
    statusBehind: "⚡ {delta} palavras para recuperar",
    statusOnTrack: "✅ Exatamente no ritmo!",
    paceTarget: "Meta: {wpd} palavras/dia · Hoje: {today} palavras",
    paceExpected: "Esperado: {n}",
    paceGoal: "Meta: {n}",
    actionCurrentLesson: "Lição atual",
    actionAllLessons: "Todas as lições",
    actionFlashcards: "Flashcards",
    actionProgress: "Meu progresso",
    actionGoals: "Minhas metas",
    actionMyVocabulary: "Meu Vocabulário",
    actionGrammarLab: "Laboratório de Gramática",
    actionListenSpeak: "Laboratório de Ouvir e Falar",
    lessonsSub: "{count} tópicos · {words} palavras",
    cardsDue: "{n} cartões para hoje!",
    allCaughtUp: "Tudo em dia! 🎉",
    progressSub: "Gráficos, precisão, crescimento de vocabulário",
    myVocabSub: "Explore todas as palavras que você aprendeu",
    listenSpeakSub: "Pratique a fala com o Babi",
    goalsSub: "{words} palavras · {days} dias",
    apiCost: "💰 Rastreador de custos API",
    since: "desde {date}",
    resetBtn: "↺ Redefinir",
    totalTokens: "tokens totais",
    inputTokens: "entrada",
    outputTokens: "saída",
    estCost: "custo est.",
    apiNote: "claude-sonnet-5 · $3/MTok in · $15/MTok out",
    tipLabel: "Dica:",
    tips: [
      "Em turco, o verbo sempre vem no final da frase — «Ben kahve içiyorum» significa «Eu café estou-bebendo.» Apenas absorva os padrões!",
      "O turco usa harmonia vocálica — os sufixos adaptam suas vogais à última vogal da raiz (ex. -lar/-ler, -da/-de). Quando você percebe, tudo se encaixa!",
      "O turco não tem gênero gramatical. Sem substantivos masculinos ou femininos — uma coisa a menos para memorizar em relação ao português ou francês!",
      "Os pronomes pessoais (ben = eu, sen = você) geralmente são omitidos porque o sufixo verbal já indica quem pratica a ação.",
      "O turco é foneticamente regular — cada letra sempre é pronunciada da mesma forma. O que você lê é exatamente o que você fala.",
      "A negação é formada adicionando -me/-ma diretamente após a raiz verbal: gel (vem) → gelme (não venha), anla (entenda) → anlama.",
      "O turco usa posposições que vêm APÓS o substantivo: «İstanbul'da» = «em Istambul» (Istambul + sufixo locativo -da).",
      "O sufixo de plural segue a harmonia vocálica: -lar após vogais posteriores (a, ı, o, u) e -ler após vogais anteriores (e, i, ö, ü).",
      "O sufixo -ıyor/-iyor/-uyor/-üyor marca o presente contínuo. Anlıyorum = Estou entendendo (anla + ıyor + um).",
      "Os verbos compostos turcos combinam um substantivo com etmek (fazer) ou olmak (ser): teşekkür etmek (agradecer), hazır olmak (estar pronto).",
    ],
  },
  lesson: {
    backBtn: "← Voltar",
    topicOf: "Tópico {order} de {total} · {words} palavras",
    translating: "Preparando a lição…",
    newWords: "✨ Novas palavras ({n})",
    alreadyLearned: "🔄 Já aprendidas ({n})",
    practiceDialogue: "🎭 Prática",
    generateDialogue: "🎭 Me dê um diálogo de prática",
    listenSpeakPractice: "🎧 Praticar no Laboratório de Ouvir e Falar",
    generatingDialogue: "Babi está preparando seu diálogo…",
    newDialogue: "↺ Novo diálogo",
    lessonSaved: "🎉 Lição salva! Adicionando {n} novos flashcards…",
    alreadyTaken: "✅ Lição já concluída",
    markComplete: "✅ Marcar lição como concluída e salvar flashcards",
  },
  vocab: {
    structure: "Estrutura",
    loadingExample: "Carregando…",
    limitReached: "↺ Limite atingido",
    anotherLeft: "↺ Outro ({n} restante)",
    anotherExample: "↺ Outro exemplo",
    analyzing: "Analisando…",
    analyzed: "✓ Analisado",
    analyzeWord: "🔍 Analisar palavra",
    analysisIntro: "Aqui está a análise gramatical passo a passo:",
    analysisError: "Não foi possível carregar a análise. Tente novamente.",
    reportMistake: "🚩 Reportar erro",
    reportWrongMeaning: "Significado de palavra incorreto",
    reportWrongSentence: "Significado de frase incorreto",
    reportOther: "Outro",
    reportChecking: "Verificando…",
    reportThanks: "✓ Obrigado por nos ajudar a melhorar!",
    reportNoIssue: [
      "Não encontrei nenhum problema aqui — isso me parece correto!",
      "Não vejo nenhum problema aqui — isso parece correto.",
      "Tudo parece estar em ordem do meu ponto de vista.",
      "Não consegui identificar nenhum problema; isso parece correto como está escrito.",
      "Isso me parece bom — não tenho nenhuma preocupação.",
      "Revisei e não encontrei nada que precise ser alterado.",
      "Nenhum problema me chamou a atenção; a tradução parece correta.",
      "Pelo que posso perceber, tudo está correto.",
      "Não consegui identificar nenhum problema; isso parece certo para mim.",
    ],
    reportCheckError: "Tive dificuldade em concluir a verificação. Por favor, tente novamente mais tarde.",
    reportOkBtn: "OK, entendi",
    reportEscalateBtn: "Encaminhar para um revisor humano",
    reportEscalatedMsg: "✓ Enviado à nossa equipe de revisão. Obrigado!",
    reportAlreadyFlaggedMsg: "✓ Isso já foi sinalizado para nossa equipe de revisão. Obrigado!",
  },
  allLessons: {
    title: "📚 Todas as lições",
    subtitle: "{count} tópicos · {words} palavras",
    searchPlaceholder: "🔍 Pesquisar tópicos ou palavras…",
    noResults: "Nenhum tópico corresponde a \"{search}\"",
    overwhelmedBanner: "Você tem {n} cartões para revisar. Revise seus flashcards antes de iniciar novas lições.",
    overwhelmedLock: "Revise os cartões primeiro",
    overwhelmedBtn: "Ir para os flashcards →",
  },
  flashcards: {
    title: "Flashcards",
    cardOf: "Cartão {current} de {total}",
    tapToReveal: "Toque para revelar",
    hearIt: "🔊 Ouvir",
    hearSentence: "🔊 Ouvir a frase.",
    allConsolidated: "Tudo consolidado",
    noDue: "Nenhum cartão pendente agora.\nSua memória está bem descansada.",
    backToDashboard: "Voltar ao painel",
    sessionComplete: "Sessão concluída",
    memoryRetention: "Eficiência de memória",
    forgotten: "Esquecido",
    struggled: "Difícil",
    recalled: "Lembrado",
    effortless: "Fácil",
    wordsConsolidated: "{retained} de {total} palavras consolidadas",
    wordsInProgress: "{retained} de {total} palavras em progresso",
    saveContinue: "Salvar e continuar",
    tomorrow: "Amanhã",
    nDays: "{n} dias",
    d1Title: "Compreensão",
    d1SubSkill: "Para melhorar as habilidades de leitura e audição",
    d1Journey: "As novas palavras começam sua jornada aqui.",
    d1Due: "{n} pendentes",
    d1Listen: "Ouvir",
    d1ShowWord: "Mostrar a palavra",
    d2Title: "Produção",
    d2SubSkill: "Para melhorar as habilidades de fala e escrita",
    d2WillStart: "Começará mais tarde",
    d2Empty: "As palavras chegam aqui após serem dominadas no conjunto de compreensão.",
    d2ModalTitle: "Prática de produção desbloqueada!",
    d2ModalBody: "Essas são palavras que você já reconhece bem. Agora treinamos você a produzi-las — é assim que você passa de entender o {targetLang} a falar.",
    d2ModalBtn: "Entendi",
    leaveConfirmTitle: "Progresso de revisão não salvo",
    leaveConfirmBody: "Você revisou cartões nesta sessão que ainda não foram salvos. Se sair agora sem salvar, esse progresso será perdido.",
    leaveConfirmSave: "Salvar e sair",
    leaveConfirmDiscard: "Descartar e sair",
    leaveConfirmCancel: "Cancelar",
    faq: {
      whyTwoQ: "Por que dois baralhos?",
      whyLaterQ: "Por que o conjunto de produção começa mais tarde?",
      whyReturnQ: "Por que as cartas continuam voltando?",
    },
  },
  grammarLab: {
    title: "📘 Laboratório de Gramática",
    subtitle: "{count} tópicos de gramática para explorar",
    backBtn: "← Voltar",
    searchPlaceholder: "🔍 Buscar tópicos de gramática…",
    noResults: "Nenhum tópico de gramática corresponde a \"{search}\"",
    allCategories: "Todas as categorias",
    allLevels: "Todos os níveis",
    notReviewedLabel: "Não revisado",
    reviewedLabel: "Revisado",
    dueBadge: "{n} para revisar",
    explanationLabel: "Explicação",
    seeReference: "(ver {term})",
    ruleLabel: "Regra",
    formsLabel: "Formas",
    translatingNote: "Traduzindo para o português...",
    practiceBtn: "▶ Praticar este tópico",
    detailedExplanationBtn: "📖 Explicação detalhada",
    practiceTitle: "Prática",
    practiceQuestion: "Como se diz isso em turco?",
    practiceOf: "{current} de {total}",
    practiceCorrectFeedback: "Correto!",
    practiceIncorrectFeedback: "Quase — a resposta era {answer}.",
    practiceNext: "Próxima →",
    practiceDone: "Prática concluída",
    practiceScore: "{correct} de {total} corretas",
    practiceNextReview: "Próxima revisão em {days} dia{plural}",
    practiceReset: "Não foi dessa vez — você verá este tópico de novo amanhã.",
    practiceAgainBtn: "Praticar de novo",
    practiceCloseBtn: "Concluído",
    categories: {
      existential: "Existencial",
      noun_suffix: "Sufixo Nominal",
      case_suffix: "Sufixo de Caso",
      verb_conjugation: "Conjugação Verbal",
      question_particle: "Partícula Interrogativa",
      copula: "Cópula",
      modal_construction: "Construção Modal",
    },
    points: {
      GP0001: { title: "Existência e Disponibilidade: var / yok", ruleSummary: "[lugar/possuidor] + [coisa] + var / yok" },
      GP0002: { title: "Sufixo de Plural: -ler / -lar", ruleSummary: "substantivo + -ler (anterior) / -lar (posterior)" },
      GP0003: { title: "Caso Locativo: -de / -da / -te / -ta", ruleSummary: "substantivo + -de/-da; -te/-ta após consoante surda" },
      GP0004: { title: "Caso Dativo: -e / -a", ruleSummary: "substantivo + -e/-a; insere-se um -y- de ligação após vogal" },
      GP0005: { title: "Caso Ablativo: -den / -dan / -ten / -tan", ruleSummary: "substantivo + -den/-dan; -ten/-tan após consoante surda" },
      GP0006: { title: "Caso Acusativo: -i / -ı / -u / -ü (objeto direto definido)", ruleSummary: "substantivo + -i/-ı/-u/-ü; -y- de ligação após vogal" },
      GP0007: { title: "Presente Contínuo — Afirmativo: -iyor", ruleSummary: "radical verbal + -iyor + terminação pessoal" },
      GP0008: { title: "Presente Contínuo — Negativo: -mıyor / -miyor / -muyor / -müyor", ruleSummary: "radical verbal + -mıyor/-miyor/-muyor/-müyor + terminação pessoal" },
      GP0009: { title: "Presente Contínuo — Interrogativo: -iyor mu", ruleSummary: "radical + -iyor + mu(+pessoal); onlar: radical + -iyorlar + mı" },
      GP0010: { title: "Partícula Interrogativa Sim/Não: mı / mi / mu / mü", ruleSummary: "[palavra] + partícula separada mı/mi/mu/mü ?" },
      GP0011: { title: "Pretérito Simples (Definido): -di / -dı / -du / -dü / -ti / -tı / -tu / -tü", ruleSummary: "radical verbal + -di/-dı/-du/-dü (ou -ti/... após surda) + terminação pessoal" },
      GP0012: { title: "Terminações Predicativas do Verbo 'Ser' (Presente): -(y)ım, -sin, -ø, -(y)ız, -siniz", ruleSummary: "predicado + -(y)ım / -sin / -ø / -(y)ız / -siniz / (-lar)" },
      GP0013: { title: "Sufixos Possessivos: meu / seu / dele-dela / nosso / vosso / deles", ruleSummary: "(benim/senin/...) substantivo + -im/-in/-i/-imiz/-iniz/-leri" },
      GP0014: { title: "Expressar Desejo: -mek / -mak istemek", ruleSummary: "[infinitivo -mek/-mak] + istemek (conjugado)" },
      GP0015: { title: "Pedido Cortês / Imperativo de 2ª Pessoa do Plural: -in / -iniz", ruleSummary: "radical verbal + -in/-ın/-un/-ün (cortês) ou -iniz (mais formal); -y- de ligação após vogal" },
    },
  },
  placementTest: {
    title: "🎯 Teste de Nível",
    offerTitle: "Já sabe algum turco?",
    offerBody: "Faça um teste de nível rápido — cerca de 20 perguntas — para descobrir o seu ponto de partida. Vamos ajustar a sua Lição Atual, mas todos os tópicos continuam disponíveis para explorar.",
    startBtn: "Começar Teste",
    notNowBtn: "Agora Não",
    roundLabel: "Ronda {round} de {totalRounds}",
    questionLabel: "Pergunta {n} de {total}",
    wordPrompt: "O que significa esta palavra?",
    listeningPrompt: "Ouça e selecione a palavra que ouviu",
    listeningReplay: "Repetir Áudio",
    preparingRound: "Preparando suas perguntas…",
    finishBtn: "Ver o Meu Resultado",
    resultsTitle: "O Seu Resultado de Nível",
    resultsLevel: "Foi colocado no nível {level}",
    resultsBody: "A sua Lição Atual começa agora neste nível. Pode sempre explorar qualquer tópico anterior ou posterior em Todas as Lições.",
    continueBtn: "Continuar",
  },
  goals: {
    title: "🎯 Minhas metas",
    displayName: "Nome de exibição",
    namePlaceholder: "Seu nome…",
    vocabTarget: "Meta de vocabulário",
    words: "palavras",
    minWords: "1.500 mín",
    midWords: "2.000",
    maxWords: "3.500 máx",
    courseDuration: "Duração alvo do curso",
    months: "Meses",
    month: "mês",
    monthsPlural: "meses",
    daysSummary: "= {days} dias",
    baseLanguage: "Idioma base",
    otherLanguage: "Outros idiomas (em breve)",
    selectLanguage: "Selecione um idioma…",
    ok: "OK",
    langNames: {
      English: "Inglês", Farsi: "Persa", Arabic: "Árabe",
      French: "Francês", German: "Alemão", Spanish: "Espanhol",
      Russian: "Russo", Portuguese: "Português", Chinese: "Chinês",
      Turkish: "Turco", Hindi: "Hindi", Italian: "Italiano",
    },
    targetLanguage: "Idioma alvo",
    targetLangNames: {
      Turkish: "Turco",
    },
    wordsLbl: "palavras",
    wordsPerDay: "palavras/dia",
    daysLbl: "dias",
    saved: "✅ Metas salvas!",
  },
  progress: {
    title: "📈 Meu progresso",
    memDistTitle: "Distribuição de estados de memória · {n} cartões",
    inAcquisition: "Em aquisição",
    rooted: "Enraizado",
    fluent: "Fluente",
    deeplyRetained: "Profundamente retido",
    acqDesc: "< 3d de estabilidade",
    rootedDesc: "3 – 21d de estabilidade",
    fluentDesc: "21 – 90d de estabilidade",
    retainedDesc: "90d+ de estabilidade",
    forecastTitle: "Previsão de revisão — próximos 15 dias",
    cardsDue: "Cartões pendentes",
    today: "Hoje",
    tmrw: "Amnh.",
    plusDays: "+{n}d",
    todayFull: "Hoje",
    tmrwFull: "Amanhã",
    plusDaysFull: "+{n} dias",
    goalProgress: "Progresso geral em direção à meta",
    wordsLearned: "{learned} / {target} palavras aprendidas",
    vocabGrowth: "Crescimento de vocabulário",
    noChart: "Conclua sua primeira lição para ver o gráfico! 📚",
    wordsLearnedSeries: "Palavras aprendidas",
    topicRings: "Anéis de memória por tópico",
    quickStats: "Estatísticas rápidas",
    dayStreak: "dias seguidos 🔥",
    lessonsDone: "lições concluídas",
    totalStudy: "estudo total",
    avg14Day: "média 14d",
    minUnit: "min",
    dayLabel: "Dia {n}",
    cards: "cartões",
  },
  myVocab: {
    title: "📝 Meu Vocabulário",
    summaryTitle: "{n} Palavras Encontradas",
    searchPlaceholder: "🔍 Pesquisar suas palavras…",
    allStatuses: "Todos os status",
    noResults: "Nenhuma palavra corresponde a \"{search}\"",
    noWords: "Complete uma lição para começar a construir seu vocabulário! 📚",
    completedTopicsTitle: "Tópicos Concluídos ({n} de {total})",
    noDate: "—",
  },
  badges: {
    newbie: "Novato",
    wordExplorer: "Explorador de Palavras",
    wordNerd: "Nerd das Palavras",
    wordWizard: "Mago das Palavras",
    rockstar: "Rockstar",
    expert: "Especialista",
    champion: "Campeão",
  },
  memStates: {
    inAcquisition: "Em aquisição",
    rooted: "Enraizado",
    fluent: "Fluente",
    deeplyRetained: "Profundamente retido",
  },
  chat: {
    subtitle: "Seu tutor de turco",
    greetWords: ["Oi", "Olá", "Salve"],
    greeting: "{greet} {name},\n\nPergunte-me qualquer coisa sobre o turco — gramática, vocabulário, cultura — ou sobre como usar este aplicativo.",
    placeholder: "Pergunta sobre o turco ou o app…",
    error: "Desculpe, não consegui conectar. Por favor, tente novamente.",
    escalationFallback: "Desculpe, não consegui ajudar totalmente com isso. Encaminhei isso para nossa equipe, e você receberá uma resposta por e-mail — normalmente em 2 dias úteis. Você também pode entrar em contato diretamente pelo support@speafy.com.",
    welcome: "Olá, {name}! 👋 Bem-vindo(a) ao Speafy! Sou o Babi, e estou aqui para duas coisas: ajudar você a conhecer o aplicativo e responder a qualquer pergunta que tiver sobre {targetLanguage}.\n\nComece com a lição atual ou escolha um tópico em «Todas as Lições». Não se esqueça de marcar cada lição como concluída quando terminar, e depois revisar os Flashcards.\n\nMe pergunte quando quiser — sobre o aplicativo ou sobre {targetLanguage}.\n\nBoa sorte na sua jornada de aprendizado! 😊",
    lessonLimit: "Você já completou {limit} lições hoje — esforço incrível! 🌟\n\nPara manter seu aprendizado sustentável e evitar sobrecarregar sua fila de flashcards, há um limite diário de {limit} lições.\n\nDê ao seu cérebro um tempo para consolidar o que aprendeu hoje. Que tal uma sessão de revisão de flashcards em vez disso?\n\nEstou aqui amanhã para mais! 😊",
    streakDecayed: "Bem-vindo de volta! 👋 Você ficou fora {days} dia(s). Graças aos {protection} Dias de Proteção de Sequência 🛡️ que você conquistou, sua sequência caiu apenas de {oldStreak} para {newStreak} em vez de desaparecer completamente. Vamos continuar construindo!",
    streakWiped: "Bem-vindo de volta! 👋 Você ficou fora {days} dia(s) — mais do que os {protection} Dias de Proteção de Sequência 🛡️ que você tinha guardado, então sua sequência recomeçou em 1. Toda sequência começa em algum lugar — vamos reconstruí-la!",
    weeklyRecapFallback: "Oi! 👋 Eu queria trazer seu resumo semanal, mas estou com dificuldade para montá-lo agora. De qualquer forma, um aviso rápido — você está numa sequência de {streak} dia(s), continue assim! 🔥",
    dailyPlanQuestion1: "Oi! 👋 Quanto tempo você tem para estudar hoje?",
    dailyPlanQuestion2: "Olá! 😊 Tenho um plano de estudos para você — quantos minutos você pode dedicar hoje?",
    dailyPlanQuestion3: "Pronto para o plano de hoje? 🎯 Só me diga mais ou menos quanto tempo você tem.",
    dailyPlanClarify: "Desculpe, não entendi bem! Você pode me dar um número aproximado, tipo '20' ou '30 minutos'?",
    dailyPlanUnreasonable: "Isso não parece uma sessão de estudo típica! Você pode me dar algo entre 5 minutos e cerca de 5 horas?",
    dailyPlanGiveUp: "Sem problemas — quando estiver pronto, é só ir para os Flashcards ou sua Lição Atual e começar! 😊",
    dailyPlanFallback: "Já anotei seu tempo disponível, mas estou com dificuldade para montar o plano de hoje agora. Enquanto isso, os Flashcards são sempre uma boa opção se você tiver cartões pendentes! 😊",
    sendBtn: "Enviar",
    askBabi: "Perguntar ao Babi",
    voiceConsentTitle: "Ativar o chat de voz com a Babi?",
    voiceConsentBody: "A Babi usará o seu microfone para ouvi-lo e o seu alto-falante para responder. A sua fala é convertida em texto — a gravação de áudio em si nunca é guardada. O texto pode ser mantido por até 30 dias. Consulte a nossa Política de Privacidade para mais detalhes.",
    voiceConsentPrivacyLink: "Política de Privacidade",
    voiceConsentAllow: "Permitir microfone",
    voiceConsentDecline: "Agora não",
    voiceDenied: "O chat de voz não está disponível sem acesso ao microfone. Pode continuar a conversar digitando — toque no ícone do microfone a qualquer momento para tentar novamente.",
    voiceDeviceInUse: "O seu microfone parece estar a ser usado noutro lugar — feche outras apps que o estejam a usar e tente novamente.",
    voiceError: "Algo correu mal com o chat de voz. Tente novamente.",
    voiceStarting: "A iniciar… aguarde",
    voiceListening: "A ouvir…",
    voiceProcessing: "A perceber…",
    voiceReviewHint: "Toque para editar, ou isto será enviado automaticamente em alguns segundos.",
    voiceSendNow: "Enviar agora",
    voiceDiscard: "Descartar",
    voiceEditTranscript: "Editar o que a Babi ouviu",
    voiceBadgeLabel: "Enviado por voz",
    voiceDidntCatch: "Não percebi — toque no microfone para tentar novamente.",
    voiceSpeaking: "A Babi está a falar…",
    voiceTtsUnavailable: "O áudio não estava disponível para essa resposta — a mostrar o texto em vez disso.",
    voiceTtsUnavailableLanguage: "A resposta falada da Babi ainda não está disponível em {language}.",
    voiceTapToHear: "Toque para ouvir a resposta da Babi",
    voiceNotEntitled: "O chat de voz com a Babi é um recurso premium — atualize o seu plano para o usar.",
    voiceNoBalance: "Utilizou todos os seus minutos de voz deste ciclo. Serão renovados no próximo ciclo.",
    voiceOtherTabActive: "O chat de voz já está ativo noutro separador.",
    voiceLowBalanceNudge: "Os seus minutos de voz deste ciclo estão a acabar.",
    voiceLowMinutesHeadsUp: "Os seus minutos de voz deste ciclo estão a acabar.",
    voiceGetMoreMinutes: "Obter mais minutos",
    voiceStopBtn: "Parar",
    voiceMicButtonLabel: "Chat de voz",
    voiceBannerDismiss: "Dispensar",
  },
  settings: {
    title: "Configurações",
    accountSection: "Conta",
    linkedGoogle: "Vinculado ao Google",
    emailAccountBadge: "Conta de e-mail",
    changeNameBtn: "Alterar nome de usuário",
    nameSaveBtn: "Salvar",
    nameCancelBtn: "Cancelar",
    nameSaving: "Salvando…",
    passwordLabel: "Senha",
    passwordSub: "Enviar um link de redefinição para seu e-mail",
    passwordSent: "Enviado ✓",
    passwordResetBtn: "Redefinir",
    subscriptionSection: "Assinatura",
    subscriptionAdminLabel: "Conta de administrador",
    subscriptionAdminSub: "Você tem acesso completo e permanente a todos os recursos.",
    subscriptionReviewerLabel: "Acesso de revisor",
    subscriptionReviewerSub: "Você tem acesso gratuito a todos os recursos como revisor do aplicativo.",
    subscriptionProPlan: "Speafy Pro — {plan}",
    subscriptionElitePlan: "Speafy Elite — {plan}",
    subscriptionPlanAnnual: "Anual",
    subscriptionPlanMonthly: "Mensal",
    subscriptionRenews: "Renova em {date}",
    subscriptionActive: "Ativa",
    subscriptionManageLink: "Faturamento e faturas",
    subscriptionCancelLink: "Cancelar ou pausar assinatura",
    subscriptionPaymentFailedLabel: "Seu último pagamento falhou",
    subscriptionPaymentFailedSub: "Pagamento falhou em {date}",
    subscriptionPaymentFailedSubNoDate: "Atualize seu método de pagamento para manter seu acesso Pro",
    subscriptionUpdatePaymentLink: "Atualizar método de pagamento ↗",
    subscriptionCancelledPending: "Seu plano termina em {date} — você manterá o acesso Pro até lá",
    subscriptionPausedLabel: "Assinatura pausada",
    subscriptionPausedSub: "Retoma automaticamente em {date} — você será cobrado(a) integralmente por um novo período, a menos que retome antes",
    subscriptionPausedSubNoDate: "Retoma automaticamente após 3 meses, a menos que você retome antes",
    subscriptionResumeBtn: "Retomar agora",
    subscriptionResuming: "Retomando…",
    pausePendingLabel: "Pausa agendada",
    pausePendingSub: "Entra em vigor em {date}, no fim do seu período de faturamento atual",
    manageOfferTitle: "Pensando em cancelar?",
    manageOfferSub: "Pause em vez disso — você manterá seu progresso até {date}, depois a assinatura será retomada automaticamente após 3 meses e você será cobrado(a) integralmente por um novo período, a menos que retome antes.",
    manageOfferPauseBtn: "Pausar em vez disso",
    manageOfferContinueLink: "Cancelar mesmo assim",
    manageOfferDismiss: "Deixa pra lá",
    pauseOfferLabel: "Precisa de uma pausa?",
    pauseOfferSub: "Pause sua assinatura por 3 meses em vez de cancelar — mantenha seu progresso, retome quando quiser.",
    pauseOfferBtn: "Pausar assinatura",
    pauseConfirmP1: "Pausar sua assinatura Speafy Pro?",
    pauseConfirmC1: "Seu período de faturamento atual continua até {date} — você mantém tudo o que já pagou.",
    pauseConfirmC2: "Durante a pausa, novas Lições ficam bloqueadas (como em um plano gratuito vencido), mas você pode continuar revisando seus Flashcards normalmente.",
    pauseConfirmC3: "A pausa dura 3 meses fixos. Se você não retomar manualmente antes disso, sua assinatura será retomada automaticamente e você será cobrado(a) integralmente por um novo período.",
    pauseConfirmBtn: "Confirmar pausa",
    pausing: "Pausando…",
    pauseFailedGeneric: "Algo deu errado ao pausar sua assinatura. Tente novamente ou entre em contato com o suporte.",
    manageLinkLoading: "Carregando…",
    manageLinkFailedGeneric: "Não foi possível carregar um link de gerenciamento agora. Tente novamente.",
    resumeConfirmP1: "Retomar sua assinatura Speafy Pro agora?",
    resumeConfirmC1: "Você será cobrado(a) integralmente por um novo período de faturamento imediatamente.",
    resumeConfirmBtn: "Sim, retomar agora",
    resumeFailedGeneric: "Algo deu errado ao retomar sua assinatura. Tente novamente ou entre em contato com o suporte.",
    subscriptionLastCharge: "Última cobrança: {amount} em {date} — {status}",
    subscriptionLastChargePaid: "Pago",
    subscriptionLastChargeFailed: "Falhou",
    tierChangePendingLabel: "Mudança de plano agendada",
    tierChangePendingToElite: "A mudar para Elite em {date}",
    tierChangePendingToBasic: "A mudar para Pro em {date}, no final do seu período de faturação atual",
    tierUpgradeToEliteLink: "Atualizar para Elite",
    tierDowngradeToBasicLink: "Voltar para Pro",
    tierUpgradeConfirmTitle: "Atualizar para Elite?",
    tierUpgradeConfirmSub: "Será cobrada a diferença proporcional hoje, e terá de imediato as 3 horas de conversa por voz da Elite com a Babi — {price}/{interval} a partir de agora.",
    tierDowngradeConfirmTitle: "Voltar para Pro?",
    tierDowngradeConfirmSub: "Manterá a Elite até {date}, depois mudará para Pro na próxima data de faturação — sem custo hoje.",
    tierUpgradeConfirmBtn: "Sim, atualizar agora",
    tierDowngradeConfirmBtn: "Sim, voltar para Pro",
    tierChangeBusy: "A atualizar…",
    tierChangeFailedGeneric: "Ocorreu um problema ao mudar o seu plano. Tente novamente ou contacte o suporte.",
    voiceMinutesLabel: "Minutos de voz ({tier})",
    voiceTierElite: "Elite",
    voiceTierBasic: "Pro",
    voiceTierTrial: "Teste",
    voiceTierAdmin: "Admin",
    voiceTierViewer: "Visualizador",
    voiceMinutesUsed: "{used} usados de {limit} neste ciclo",
    voiceMinutesPurchasedExtra: "Mais {extra} comprados — usados depois de esgotar seus minutos mensais e nunca expiram",
    yourDataSection: "Seus Dados",
    marketingLabel: "Consentimento de Comunicações de Marketing",
    marketingSub: "Atualizações, notificações e ofertas especiais",
    voiceConsentLabel: "Chat de Voz com a Babi",
    voiceConsentSub: "Permita que a Babi o ouça e responda em voz alta",
    privacyLegalSection: "Privacidade, Termos e Legal",
    privacyPolicyLabel: "Política de Privacidade",
    privacyPolicySub: "Como coletamos, usamos e protegemos seus dados",
    viewLink: "Ver",
    termsLabel: "Termos de Serviço",
    termsSub: "Regras e condições que regem seu uso",
    refundLabel: "Política de Reembolso",
    refundSub: "Elegibilidade e como solicitar um reembolso",
    cookieSettingsLabel: "Configurações de Cookies",
    cookieSettingsSub: "Gerencie cookies analíticos e funcionais",
    manageLink: "Gerenciar",
    privacySection: "Privacidade e dados",
    exportLabel: "Exportar meus dados",
    exportSub: "Baixar um arquivo JSON do seu perfil, progresso e flashcards",
    exportBtn: "Exportar",
    exportDone: "✓ Baixado",
    cacheLabel: "Cache local",
    cacheSub: "O progresso de aprendizado e frases de exemplo são armazenados em cache no seu navegador para velocidade.",
    cookieLabel: "Configurações de cookies e privacidade",
    cookieSub: "As preferências de análise e cookies são gerenciadas no site do Speafy",
    privacyLink: "Política de privacidade ↗",
    aboutSection: "Sobre",
    aiTutorLabel: "Tutor de IA",
    aiTutorSub: "Desenvolvido com Claude Sonnet — Anthropic",
    algoLabel: "Algoritmo de memória",
    algoSub: "FSRS v4.5 — Agendador de Repetição Espaçada",
    learningSection: "Aprendizagem",
    placementTestLabel: "Teste de nível",
    placementTestSubNew: "Descubra o seu nível inicial com um teste rápido",
    placementTestSubRetake: "Último nível: {level} · pode repetir quando quiser",
    placementTestBtnNew: "Fazer Teste",
    placementTestBtnRetake: "Repetir Teste",
    versionLabel: "Versão",
    appearanceSection: "Aparência",
    darkModeLabel: "Modo escuro",
    darkModeSub: "Mudar para um esquema de cores escuro",
    largeTextLabel: "Texto grande",
    largeTextSub: "Aumenta o tamanho do texto para leitura mais fácil",
    babiCheckinsSection: "Check-ins do Babi",
    babiDailyNudgeLabel: "O lembrete diário do Babi",
    babiDailyNudgeSub: "O Babi pergunta quanto tempo você tem e sugere um plano de estudos todos os dias",
    babiWeeklyReportLabel: "O relatório semanal do Babi",
    babiWeeklyReportSub: "Um resumo semanal do seu progresso, uma vez por semana",
    dangerSection: "Zona de perigo",
    resetLabel: "Redefinir todo o progresso",
    resetSub: "Apaga sua sequência, flashcards e histórico de lições. Não pode ser desfeito.",
    resetBtn: "Redefinir",
    resetConfirmP1: "Redefinir todo o progresso? Isso excluirá permanentemente:",
    resetConfirmC1: "Todos os {n} flashcards e seus dados de memória",
    resetConfirmC2: "Sua sequência ({n} dias) e histórico de estudos",
    resetConfirmC3: "Todos os registros de lições concluídas, em todos os idiomas que você está aprendendo",
    resetConfirmC4: "Seu progresso de revisão no Laboratório de Gramática",
    resetConfirmP2: "Sua conta, nome e configurações de idioma serão mantidos.",
    resetConfirmBtn: "Sim, redefinir tudo",
    resetting: "Redefinindo…",
    resetDone: "✅ Progresso redefinido! Você está começando do zero.",
    deleteLabel: "Excluir conta",
    deleteSub: "Exclui permanentemente sua conta e todos os dados. Não pode ser desfeito.",
    deleteBtn: "Excluir conta",
    deleteConfirmP1: "Excluir permanentemente sua conta do Speafy? Isso irá imediata e irreversivelmente excluir:",
    deleteConfirmC1: "Seu perfil (nome, idioma, objetivos)",
    deleteConfirmC2: "Todos os {n} flashcards e dados de memória",
    deleteConfirmC3: "Seu histórico completo de aprendizado e sequência",
    deleteConfirmC4: "Sua conta de autenticação do Firebase",
    deleteConfirmPrompt: "Digite DELETE (em maiúsculas) para confirmar:",
    deleteConfirmBtn: "Excluir permanentemente minha conta",
    deleting: "Excluindo…",
    cancelBtn: "Cancelar",
  },
  trial: {
    daysLeftBadge: "⏱ {n} dias restantes",
    expiredBadge: "Teste encerrado · Atualizar ↑",
    pausedBadge: "⏸ Pausada",
    proBadge: "✦ Plano Pro",
    eliteBadge: "✦ Plano Elite",
  },
  paywall: {
    back: "← Voltar",
    title: "Atualizar para Speafy Pro",
    subTrialExpired: "Seu período de teste gratuito terminou. Atualize para continuar aprendendo.",
    subDefault: "Desbloqueie todas as lições e revisão de flashcards.",
    features: [
      "Todas as {count} lições completamente desbloqueadas",
      "Chat ilimitado com Babi, seu tutor de IA",
      "Revisão inteligente de flashcards FSRS",
      "Acompanhamento de progresso e análises de memória",
      "Áudio nativo em cada palavra",
      "Diálogos de prática",
      "Interface multilíngue",
    ],
    tierPro: "Pro",
    tierElite: "Elite",
    eliteFeatures: [
      "Tudo o que há no Speafy Pro",
      "Laboratório de Ouvir e Falar — prática de conversação guiada com a Babi",
      "3 horas de conversa por voz com a Babi todos os meses",
      "Compre minutos de voz extra a qualquer momento — $3/hora",
    ],
    billingMonthly: "Mensal",
    billingYearly: "Anual",
    saveBadge: "Economize 25%",
    pricePerMonth: "/mês",
    priceBilledYearly: "cobrado anualmente",
    cta: "Iniciar Speafy Pro →",
    ctaElite: "Iniciar Speafy Elite →",
    fine: "Cancele a qualquer momento · Pagamento seguro via Paddle",
    bannerExpired: "Seu período de teste gratuito terminou.",
    bannerActive: "Teste gratuito — {n} dias restantes.",
    bannerBtn: "Atualizar ↑",
    settingsFreePlan: "Plano Gratuito",
    pausedTitle: "Sua assinatura está pausada",
    pausedSub: "Retome sua assinatura em Configurações para desbloquear novas lições novamente.",
    pausedGoToSettingsBtn: "Ir para Configurações",
    alreadyProTitle: "Você já é Pro!",
    alreadyProSub: "Sua assinatura está ativa — não precisa comprar novamente.",
    alreadyProGoHomeBtn: "Ir para o Início",
    settingsTrialRemaining: "Teste — {n} dias restantes",
    settingsTrialEnded: "Teste encerrado — atualize para desbloquear todas as lições",
    settingsFreeForever: "Continue de onde parou — atualize para desbloquear todas as lições",
    settingsUpgradeBtn: "Atualizar",
  },
  authAction: {
    verifyingTitle: "Verificando seu e-mail…",
    verifiedTitle: "Seu e-mail foi verificado!",
    verifiedBody: "Está tudo pronto. Continue no Speafy para seguir aprendendo.",
    continueBtn: "Continuar no Speafy →",
    verifyErrorTitle: "Este link expirou",
    verifyErrorBody: "Este link de verificação não é mais válido. Faça login e enviaremos um novo para você.",
    resendBtn: "Reenviar e-mail de verificação",
    resendSent: "Enviado ✓",
    resendError: "Não foi possível reenviar. Tente novamente em instantes.",
    signInBtn: "Entrar",
    verifyingReset: "Verificando seu link…",
    resetTitle: "Redefina sua senha",
    resetBodyFor: "Escolha uma nova senha para {email}",
    newPasswordPh: "Nova senha",
    confirmPasswordPh: "Confirme a nova senha",
    resetSubmitBtn: "Redefinir senha",
    resettingBtn: "Redefinindo…",
    resetSuccessTitle: "Senha atualizada!",
    resetSuccessBody: "Sua senha foi alterada. Faça login com sua nova senha.",
    resetErrorTitle: "Este link expirou",
    resetErrorBody: "Este link de redefinição de senha não é mais válido. Solicite um novo na tela de login.",
    passwordMismatch: "As senhas não coincidem.",
    passwordTooShort: "A senha deve ter pelo menos 6 caracteres.",
    genericError: "Algo deu errado. Tente novamente.",
    invalidTitle: "Este link é inválido ou expirou",
    invalidBody: "O link que você seguiu não é mais válido. Volte ao Speafy e tente novamente.",
    backToSignIn: "Voltar ao login",
  },

  teacherDash: {
    link: "Painel do professor",
    title: "Painel do professor",
    backHome: "Voltar ao início",
    studentBadge: "O teu professor: {name}",
    intro: "Tudo o que precisa para trazer os seus alunos para o Speafy e acompanhar o progresso deles.",
    referralTitle: "O seu link de indicação",
    referralBody: "Partilhe este link com os seus alunos. Quem se registar através dele fica associado a si como professor.",
    copy: "Copiar link",
    copied: "Copiado",
    studentsTitle: "Os seus alunos",
    studentsLoading: "A carregar os seus alunos…",
    studentsError: "Não foi possível carregar os seus alunos neste momento.",
    retry: "Tentar novamente",
    studentsEmpty: "Ainda não tem alunos. Partilhe o seu link de indicação — os alunos que entrarem através dele aparecem aqui.",
    colName: "Aluno",
    colJoined: "Entrou em",
    colStatus: "Subscrição",
    colCommission: "Comissão ganha",
    colGrammar: "Foco gramatical",
    statusActive: "Ativa",
    statusTrial: "Teste",
    statusNone: "Sem subscrição",
    commissionNote: "Isto é o que ganhou com cada aluno no total. O seu saldo disponível para pagamento é apresentado abaixo.",
    commissionCapReached: "Período de 12 meses terminado",
    grammarNote: "Os dados de erros gramaticais só são exibidos para alunos com assinatura ativa.",
    studentUnnamed: "Aluno",
    curriculumTitle: "Referência do currículo",
    curriculumBody: "Consulte todos os tópicos e palavras que os seus alunos aprendem, por ordem.",
    curriculumLink: "Abrir a referência do currículo",
    profileTitle: "O seu perfil de professor",
    profileBody: "É assim que vai aparecer no diretório de professores do Speafy quando for lançado.",
    profileBio: "Breve apresentação",
    profileBioPh: "Uma ou duas frases sobre si e sobre como ensina.",
    profilePhoto: "Foto",
    photoChoose: "Escolher foto",
    photoUploading: "A enviar…",
    photoRemove: "Remover",
    photoHint: "PNG ou JPG, até 200 KB.",
    photoTypeErr: "Escolha uma imagem PNG ou JPG.",
    photoSizeErr: "Essa imagem tem mais de 200 KB — escolha uma mais pequena.",
    photoUploadErr: "Falha no envio. Tente novamente.",
    profileLink: "Site pessoal ou link de rede social",
    profileLinkPh: "www.exemplo.com",
    profileLanguages: "Idiomas que ensino",
    profileLanguagesHint: "Escolha os idiomas que você ensina. Mais opções serão liberadas à medida que a Speafy as adicionar como idiomas do curso.",
    profileLanguagesSoon: "Em breve",
    save: "Guardar",
    saving: "A guardar…",
    saved: "Guardado",
    urlError: "Isto não parece um endereço web. Verifique-o ou deixe o campo em branco.",
    termsStatusAccepted: "Termos de Parceria para Professores — Aceites em {date}",
    termsStatusPending: "Termos de Parceria para Professores — Ainda não aceites",
    termsVersionLabel: "Versão {version}",
    termsView: "Ver os Termos aceites",
    payoutTitle: "Pagamento",
    payoutLoading: "A carregar o estado do seu pagamento…",
    payoutError: "Não foi possível carregar o estado do seu pagamento agora.",
    payoutBalance: "O seu saldo atual: {balance}",
    payoutNotEligible: "Poderá solicitar um pagamento assim que o seu saldo atingir {threshold}.",
    payoutAlreadyRequested: "Pagamento solicitado — entraremos em contacto.",
    requestPayoutBtn: "Solicitar pagamento",
    payoutRequestFailed: "Ocorreu um erro ao enviar o seu pedido. Tente novamente.",
    payoutConfirmTitle: "Solicitar um pagamento?",
    payoutConfirmBody: "Tem atualmente {balance} disponíveis para solicitar.\n\nIsto inicia um processo de pagamento manual — nenhum dinheiro é movimentado automaticamente. Analisaremos o seu pedido e entraremos em contacto por e-mail.",
    payoutConfirmBtn: "Solicitar pagamento",
    payoutConfirmCancel: "Cancelar",
  },

  teacherTerms: {
    screenTitle: "Termos de Parceria para Professores",
    contents: "Índice",
    lastUpdatedLabel: "Última atualização",
    effectiveLabel: "Data de entrada em vigor",
    bannerTitle: "Ação necessária",
    bannerBody: "Leia e aceite os Termos de Parceria para Professores para continuar como parceiro.",
    bannerCta: "Ler e aceitar",
    acceptedOn: "Aceitou estes Termos em {date}.",
    acceptedVersion: "Versão aceite: {version}",
    accepting: "A registar a sua aceitação…",
    acceptError: "Não foi possível registar a sua aceitação neste momento. Tente novamente.",
    draftNotice: "Estes Termos ainda não são definitivos. Poderá aceitá-los assim que a data de entrada em vigor for definida.",
  },
};

export default pt;
